export enum Currency {
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP",
  CHF = "CHF",
}

export namespace Currency {

  export function symbol(currency: Currency): string {
    switch (currency) {
      case Currency.EUR:
        return "€";
      case Currency.USD:
        return "$";
      case Currency.GBP:
        return "£";
      case Currency.CHF:
        return "CHF";
    }
  }
}